import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './KuisionerList.css';

const KategoriCard = ({ title, onClick }) => (
  <div className="kategori-card" onClick={onClick}>
    <h3>{title}</h3>
  </div>
);

const KuisionerList = () => {
  const [kuisioner, setKuisioner] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  // Fetch data dari API saat komponen dimuat
  useEffect(() => {
    const fetchKuisioner = async () => {
      try {
        const response = await fetch('https://freddway-v2.credibug.com/api/kategori');
        if (!response.ok) {
          throw new Error('Gagal memuat kategori');
        }
        const data = await response.json();
        console.log('Data dari API:', data); // Debugging
        setKuisioner(data);
      } catch (err) {
        console.error('Error fetching data:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
  
    fetchKuisioner();
  }, []);
  

  const handleKategoriClick = (title) => {
    navigate(`/question/${title}`);
  };

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error}</p>;

  return (
    <div className="kategori-container">
      {kuisioner.length > 0 ? (
        kuisioner.map((q) => (
          <KategoriCard 
            key={q.id} 
            title={`${q.title} - ${q.question_count || 0} Questions`} 
            onClick={() => handleKategoriClick(q.title)}
          />
        ))
      ) : (
        <p>Tidak ada kategori tersedia.</p>
      )}
    </div>
  );
  
};

export default KuisionerList;
